import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { FormSelect, useWatch, useZionFormContext } from '@fs/zion-form'
import { Skeleton } from '@fs/zion-ui'
import { useCountryContext } from '../../providers'

export const NAME = 'country'

export function CountryField({ disabled, initialValue }) {
  const [t] = useTranslation()
  const { countries, preferredCountry, loading } = useCountryContext()

  const { setValue } = useZionFormContext()
  const value = useWatch({ name: NAME })

  useEffect(() => {
    if (!value && !loading) {
      let newValue = initialValue
      if (!initialValue) {
        const country = countries.find(({ countryCode }) => countryCode === preferredCountry)
        newValue = country?.value
      }
      if (newValue !== undefined) {
        setValue(NAME, newValue)
      }
    }
  }, [countries, setValue, initialValue, value, loading, preferredCountry])

  if (loading) {
    return <Skeleton.TextInput />
  }
  return (
    <FormSelect
      name={NAME}
      label={`${t('form.field.regional-country.label', 'Country or Location')}: *`}
      // remove `countryCode` from the DOM
      options={countries.map(({ countryCode, ...rest }) => ({ ...rest }))}
      disabled={disabled}
      required
    />
  )
}
